import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette, MediaUpload, MediaUploadCheck} from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, ToggleControl, __experimentalUnitControl as UnitControl, RangeControl, Button } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGolColor,
        hfcFootBGolRange
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfc-footer-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();
    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/image',
        'core/heading',
        'core/paragraph',
        'core/social-links',
        'core/social-link',
        'core/navigation',
        'core/navigation-link',
        'core/buttons',
        'core/button'
    ];
    const TEMPLATE = [['core/group', {
        tagName: 'footer'
    }, [
            ['core/group', {
                className: ''
            },
                [
                    ['core/columns', {
                        verticalAlignment: 'center',
                        className: 'hfc-cols-footer-2 hfc-columns-1'
                    }, [
                            ['core/column', {
                                width: '20%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-1'
                            }, [
                                    ['core/heading', {
                                        content: 'Navigation',
                                        level: 4
                                    }],
                                    ['core/navigation', {
                                        className: 'hfc-nav-footer-2',
                                        overlayMenu: 'never'
                                    }, [
                                            ['core/navigation-link', {
                                                label: 'Home',
                                                url: '#',
                                                rel: 'nofollow',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Service',
                                                url: '#',
                                                rel: 'nofollow',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Contact',
                                                url: '#',
                                                rel: 'nofollow',
                                                className: ''
                                            }],
                                        ]]
                                ]],

                            ['core/column', {
                                width: '20%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-2'
                            }, [
                                    ['core/heading', {
                                        content: 'Services',
                                        level: 4
                                    }],
                                    ['core/navigation', {
                                        className: 'hfc-nav-footer-2',
                                        overlayMenu: 'never'
                                    }, [
                                            ['core/navigation-link', {
                                                label: 'Drone Mapping',
                                                url: '#',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Commercial',
                                                url: '#',
                                                rel: 'nofollow',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Real Store',
                                                url: '#',
                                                rel: 'nofollow',
                                                className: ''
                                            }]
                                        ]]
                                ]],
                            ['core/column', {
                                width: '20%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-3'
                            }, [
                                    ['core/image', {
                                        url: require('../../public/img/hfc-footer-logo-demo.png'),
                                        className: 'hfc-footer-site-about-logo'
                                    }],
                                    ['core/separator', {
                                    }],
                                    ['core/social-links', { className: 'hfc-sl-footer-1' }, [
                                        ['core/social-link', {
                                            service: 'x',
                                            url: '#'
                                        }],
                                        ['core/social-link', {
                                            service: 'facebook',
                                            url: '#'
                                        }],
                                        ['core/social-link', {
                                            service: 'linkedin',
                                            url: '#'
                                        }],
                                        ['core/social-link', {
                                            service: 'pinterest',
                                            url: '#'
                                        }]
                                    ]]
                                ]],
                            ['core/column', {
                                width: '20%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-3'
                            }, [
                                    ['core/heading', {
                                        content: 'Project',
                                        level: 4
                                    }],
                                    ['core/navigation', {
                                        className: 'hfc-nav-footer-2',
                                        overlayMenu: 'never'
                                    }, [
                                            ['core/navigation-link', {
                                                label: 'Advertise',
                                                url: '#',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'News',
                                                url: '#',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Careers',
                                                url: '#',
                                                className: ''
                                            }],
                                        ]]
                                ]],
                            ['core/column', {
                                width: '20%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-3'
                            }, [
                                    ['core/heading', {
                                        content: 'Teams',
                                        level: 4
                                    }],
                                    ['core/navigation', {
                                        className: 'hfc-nav-footer-2',
                                        overlayMenu: 'never'
                                    }, [
                                            ['core/navigation-link', {
                                                label: 'Partner',
                                                url: '#',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Updates',
                                                url: '#',
                                                className: ''
                                            }],
                                            ['core/navigation-link', {
                                                label: 'Jobs',
                                                url: '#',
                                                className: ''
                                            }],
                                        ]]
                                ]],

                        ]],
                    ['core/separator', {
                        className: 'columns-separator'
                    }],
                    ['core/columns', {
                        verticalAlignment: 'center',
                        className: 'hfc-cols-footer-2 hfc-columns-2'
                    },
                        [
                            ['core/column', {
                                width: '33.33%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-1'
                            }, [
                                    ['core/paragraph', {
                                        content: 'Copyright &copy; 2024 Your Site',
                                    }],
                                ]],
                            ['core/column', {
                                width: '33.33%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-2'
                            }, [
                                    ['core/navigation-link', {
                                        label: 'Lets Talk',
                                        url: '#',
                                        className: ''
                                    }],
                                ]],
                            ['core/column', {
                                width: '33.33%',
                                className: 'hfc-footer-2-menu hfc-common-column hfc-footer-menu-col-num-3'
                            }, [
                                    ['core/paragraph', {
                                        content: 'All rights reserved',
                                    }],
                                ]],

                        ]
                    ]
                ]
            ],

        ]]];
    const hfcDynamicStyles = `/*Compatable with generatePress*/
       .wp-block-group__inner-container {
           max-width: 100% !important;
           padding: 0 !important;
           margin: 0 !important;
        }
        .editor-styles-wrapper.block-editor-writing-flow {
            padding: 0;
        }
       .editor-styles-wrapper .wp-block {
           max-width: 100%;
           margin: 0;
       }
       #${id}.hfc-main-footer-2 .hfc-cols-footer-2 ul li button{
           background: transparent;
           border: none;
       }
       #${id}.hfc-main-footer-2 .hfc-cols-footer-2 ul li:hover{
            border: transparent !important;
            box-shadow: none;
        }
        #${id}.hfc-main-footer-2 .hfc-cols-footer-2 figure{
            margin: 0;
        }
        /*Astra*/
        .ast-separate-container .edit-post-visual-editor__content-area {
            padding: 0 !important;
        }
        /*Main Css*/
        .wp-block-post-content.block-editor-block-list__layout {
            padding: 0;
        }
        .editor-styles-wrapper {
            margin: 0;
        }
        .editor-styles-wrapper .wp-block-hfc-blocks-footer-2 {
            max-width: 100% !important;
        }
        .editor-styles-wrapper .hfc-main-footer-2 .wp-block a {
            text-decoration: none;
        }
        #${id}.hfc-main-footer-2 {
            width: 100%;
            background-color: ${hfcFootBGcolor};
            position: relative;
            padding: 100px 0 60px;
            z-index: 1;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .wp-block-column figure.wp-block-image.hfc-footer-site-about-logo img {
            margin: 0 auto;
        }
        #${id}.hfc-main-footer-2  .hfc-cols-footer-2{
            max-width: ${hfcFootInnerWidth};
            margin: 0 auto;
        }
        #${id}.hfc-main-footer-2 .wp-block-navigation__container, 
        #${id}.hfc-main-footer-2 .hfc-nav-footer-2,
        #${id}.hfc-main-footer-2 .wp-block-navigation .wp-block-navigation-item {
            display: block;
            margin-bottom: 15px;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column{
            text-align: center;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column h4{
            font-size: 22px;
            font-weight: bold;
            line-height: 28px;
            color: #fff;
            color: ${hfcFootMenuTitlesColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column{
            text-align: center;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 hr{
            max-width: 400px;
            width: 100%;
            margin: 35px auto;
            background: transparent;
            border-bottom: 1px inset ${hfcFootBorderColor};
            border-top: 0;
        }
        #${id}.hfc-main-footer-2 .columns-separator{
            max-width: 700px;
            width: 100%;
            margin: 54px auto;
            background: transparent;
            border-bottom: 1px inset ${hfcFootBorderColor};
            border-top: 0;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul {
            justify-content: center;
            gap: 13px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li {
             background-color: transparent;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li a {
            padding: 0;
            margin: 0;
            background: transparent;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li svg{
            fill:${hfcFootSocialIconsColor};
            height: 20px;
            width: 20px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li svg:hover{
            fill:${hfcFootSocialIconsHoverColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav{
            margin-top: 15px;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav a{
            margin-top: 15px;
            font-size: 14px;
            font-weight: normal;
            line-height: 16px;
            color: #9f9b9b;
            color: ${hfcFootMenuLinksColor};
            display: inline !important;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 {
            padding: 0 40px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .wp-block-column p,
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content{
            font-size: 14px;
            color: ${hfcFootMenuTitlesColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav a:hover,
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content:hover{
            color: ${hfcFootMenuLinksHoverColor};
            text-decoration: underline;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .hfc-footer-menu-col-num-1{
            text-align: left;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .hfc-footer-menu-col-num-3{
            text-align: right;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 li {
            list-style: none;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content {
            text-decoration: none;
        }
        #${id}.hfc-main-footer-2 span.hfc-footer-img-overlay {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: ${hfcFootBGolColor};
            opacity: ${hfcFootBGolRange}%;
            z-index: -1;
        }
        #${id}.hfc-main-footer-2 img.hfc-footer-bg-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: -2;
        }
    @media(max-width: 781px){
            #${id}.hfc-main-footer-2{
                    padding: 50px 0 50px;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-1{
                    gap: 30px;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-2{
                    flex-direction: column-reverse;
            }
            #${id}.hfc-main-footer-2 .columns-separator{
                margin: 25px auto;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-1 .wp-block-column h1{
                    margin: 25px auto;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-2 .wp-block-column{
                    text-align: center;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-1{
                    order: 2 ;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-2{
                    order: 3;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3{
                    order: 1;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-2 p{
                margin: 0;
            }
            #${id}.hfc-main-footer-2 .hfc-columns-2{
                    gap: 10px;
            }
        }`;
    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Cross Rating Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <Heading className={'frhd__pb-heading'}>Heading Sample :</Heading>
                <UnitControl
                    label={__('Footer Inner Width :')}
                    onChange={newValue => setAttributes({ hfcFootInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcFootInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Footer Background Color :</Heading>
                <ColorPalette
                    value={hfcFootBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcFootBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Titles Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuTitlesColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuTitlesColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Items Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Menu Items Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Footer Border Color :</Heading>
                <ColorPalette
                    value={hfcFootBorderColor}
                    onChange={(colorValue) => setAttributes({ hfcFootBorderColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Social Icons Hover Color :</Heading>
                <ColorPalette
                    value={hfcFootSocialIconsHoverColor}
                    onChange={(colorValue) => setAttributes({ hfcFootSocialIconsHoverColor: colorValue })}
                    clearable={false}
                />
                <ToggleControl
                    label={
                        hfcHasFootBGimg
                            ? 'Footer Background Image :'
                            : 'Footer Background Image :'
                    }
                    checked={hfcHasFootBGimg}
                    onChange={newValue => setAttributes({ hfcHasFootBGimg: newValue })}
                    __nextHasNoMarginBottom
                    className={'frhd__component-diff'}
                />
                    {hfcHasFootBGimg && (
                    <>
                        <Heading className={'frhd__pb-heading'}>Footer Background Image :</Heading>
                        <img src={hfcFootBGimg} className={'frhd__pb-media-upload-preview'} />
                        <MediaUploadCheck>
                            <MediaUpload
                                onSelect={(media) =>
                                    setAttributes({ hfcFootBGimgObj: media.sizes, hfcFootBGimg: media.sizes.full.url })
                                }
                                allowedTypes={['image']}
                                value={hfcFootBGimg}
                                render={({ open }) => (
                                    <Button
                                        onClick={open}
                                        icon={'admin-media'}
                                        className={'frhd__gr-media-btn button button-secondary'}
                                    >Open Media Library</Button>
                                )}
                            />
                        </MediaUploadCheck>
                        <Heading className={'frhd__pb-heading'}>Footer Overlay Color :</Heading>
                        <ColorPalette
                            value={hfcFootBGolColor}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolColor: colorValue })}
                            clearable={false}
                        />
                        <RangeControl
                            label={'Footer Overlay Opacity :'}
                            value={hfcFootBGolRange}
                            onChange={(colorValue) => setAttributes({ hfcFootBGolRange: colorValue })}
                            min={0}
                            max={100}
                            __nextHasNoMarginBottom
                        />
                    </>
                )}

            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`} >
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-footer-2'}>
                  {hfcHasFootBGimg && (
                    <>
                        <span className='hfc-footer-img-overlay'></span>
                        <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                    </>
                    )}
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {
    const {
        id,
        hfcFootInnerWidth,
        hfcFootBGcolor,
        hfcFootBorderColor,
        hfcFootMenuTitlesColor,
        hfcFootMenuLinksColor,
        hfcFootMenuLinksHoverColor,
        hfcFootSocialIconsColor,
        hfcFootSocialIconsHoverColor,
        hfcHasFootBGimg,
        hfcFootBGimg,
        hfcFootBGolColor,
        hfcFootBGolRange
    } = attributes;
    const hfcDynamicStyles = `.editor-styles-wrapper {
            margin: 0;
        }
        .editor-styles-wrapper .wp-block-hfc-blocks-footer-2 {
            max-width: 100% !important;
        }
        .editor-styles-wrapper .hfc-main-footer-2 .wp-block a {
            text-decoration: none;
        }
        #${id}.hfc-main-footer-2 {
            width: 100%;
            background-color: ${hfcFootBGcolor};
            position: relative;
            padding: 100px 0 60px;
            z-index: 1;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .wp-block-column figure.wp-block-image.hfc-footer-site-about-logo img {
            margin: 0 auto;
        }
        #${id}.hfc-main-footer-2  .wp-block-group{
            max-width: ${hfcFootInnerWidth};
            margin: 0 auto;
        }
        #${id}.hfc-main-footer-2 .wp-block-navigation__container, 
        #${id}.hfc-main-footer-2 .hfc-nav-footer-2,
        #${id}.hfc-main-footer-2 .wp-block-navigation .wp-block-navigation-item {
            display: block;
            margin-bottom: 15px;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column{
            text-align: center;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column h4{
            font-size: 22px;
            font-weight: bold;
            line-height: 28px;
            color: #fff;
            color: ${hfcFootMenuTitlesColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column{
            text-align: center;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 hr{
            max-width: 400px;
            width: 100%;
            margin: 35px auto;
            background: transparent;
            border-bottom: 1px inset ${hfcFootBorderColor};
            border-top: 0;
        }
        #${id}.hfc-main-footer-2 .columns-separator{
            max-width: 700px;
            width: 100%;
            margin: 54px auto;
            background: transparent;
            border-bottom: 1px inset ${hfcFootBorderColor};
            border-top: 0;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul {
            justify-content: center;
            gap: 13px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li {
            background-color: transparent;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li a {
            padding: 0;
            margin: 0;
            background: transparent;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li svg{
            fill:${hfcFootSocialIconsColor};
            height: 20px;
            width: 20px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3 ul li svg:hover{
            fill:${hfcFootSocialIconsHoverColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav{
            margin-top: 15px;
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav a{
            margin-top: 15px;
            font-size: 14px;
            font-weight: normal;
            line-height: 16px;
            color: ${hfcFootMenuLinksColor};
            display: inline !important;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 {
            padding: 0 40px;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .wp-block-column p,
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content{
            font-size: 14px;
            color: ${hfcFootMenuTitlesColor};
        }
        #${id}.hfc-main-footer-2 .wp-block-columns .wp-block-column nav a:hover,
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content:hover{
            color: ${hfcFootMenuLinksHoverColor};
            text-decoration: underline;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .hfc-footer-menu-col-num-1{
            text-align: left;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 .hfc-footer-menu-col-num-3{
            text-align: right;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 li {
            list-style: none;
        }
        #${id}.hfc-main-footer-2 .hfc-columns-2 a.wp-block-navigation-item__content {
            text-decoration: none;
        }
        #${id}.hfc-main-footer-2 span.hfc-footer-img-overlay {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: ${hfcFootBGolColor};
            opacity: ${hfcFootBGolRange}%;
            z-index: -1;
        }
        #${id}.hfc-main-footer-2 img.hfc-footer-bg-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: -2;
        }
        @media(max-width: 781px){
                #${id}.hfc-main-footer-2{
                      padding: 50px 0 50px;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-1{
                      gap: 30px;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-2{
                     flex-direction: column-reverse;
                }
                #${id}.hfc-main-footer-2 .columns-separator{
                    margin: 25px auto;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-1 .wp-block-column h1{
                      margin: 25px auto;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-2 .wp-block-column{
                     text-align: center;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-1{
                     order: 2 ;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-2{
                     order: 3;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-1 .hfc-footer-menu-col-num-3{
                     order: 1;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-2 p{
                    margin: 0;
                }
                #${id}.hfc-main-footer-2 .hfc-columns-2{
                     gap: 10px;
                }
            }`;
    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-main-footer-2'}>
                  {hfcHasFootBGimg && (
                    <>
                        <span className='hfc-footer-img-overlay'></span>
                        <img src={hfcFootBGimg} className='hfc-footer-bg-img' />
                    </>
                  )}
                <InnerBlocks.Content />
            </div>
        </>
    )
}